import { render, staticRenderFns } from "./user_profile_feedback.vue?vue&type=template&id=d3749fae&scoped=true&"
import script from "./user_profile_feedback.vue?vue&type=script&lang=ts&"
export * from "./user_profile_feedback.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile_feedback.vue?vue&type=style&index=0&id=d3749fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3749fae",
  null
  
)

export default component.exports